import React, { Component } from 'react';
import { Card, Space, Button, Typography, Spin, Modal, Empty, Descriptions, Tag, Divider, message, Input, Radio } from 'antd';
import { BookOutlined, EyeOutlined, DeleteOutlined, LoadingOutlined, ShoppingCartOutlined, LeftOutlined } from '@ant-design/icons';
import firebase from "../../firebase"
import OtasukeCartAllSelect from "../CartSelect/OtasukeCartAllSelect";
import OtasukeCartAllSelectOtasuke from "../CartSelect/OtasukeCartAllSelectOtasuke";
import { updateItemFromSellData } from "../../utils/itemSync";

const { Title, Text } = Typography;

class MobileOtasukeCartDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            otasukeCart: {},
            loading: true,
            deleteModal: false,
            deleteId: null,
            deleteTitle: null,
            cartselect: false,
            selectedItem: {},
            carriage: 0,
        };
    }

    getCart = async () => {
        let iCollection;
        if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.maker) {
            iCollection = this.props.db.collection('items_stock').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
        } else if (this.props.org && this.props.org.maker && this.props.userOrg && this.props.userOrg.reseller) {
            iCollection = this.props.db.collection('items_stock').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
        } else if (this.props.org && this.props.org.reseller && this.props.userOrg && this.props.userOrg.buyer) {
            iCollection = this.props.db.collection('items_sell').doc(this.props.org.id).collection('buyers').doc(this.props.userOrg.id).collection('items')
        } else if (this.props.org && this.props.org.buyer && this.props.userOrg && this.props.userOrg.reseller) {
            iCollection = this.props.db.collection('items_sell').doc(this.props.userOrg.id).collection('buyers').doc(this.props.org.id).collection('items')
        }

        if (this.props.org && iCollection) {
            let urigawa = false;
            if (this.props.userOrg && this.props.userOrg.reseller && this.props.org && this.props.org.buyer) urigawa = true;
            if (this.props.userOrg && this.props.userOrg.maker && this.props.org && this.props.org.reseller) urigawa = true;

            let collection = 'address_book_buy'
            if (urigawa) collection = 'address_book_sell';

            let ab = this.props.db.collection(collection).doc(this.props.user.id)
                .collection('address_book').doc(this.props.org.id)
                .collection('address_book')
                .orderBy('dueDate', 'desc')
                .get()

            let ochRef = this.props.db.collection('otasuke_carts_history').doc(this.props.id);
            let och = ochRef.get();

            let response = await Promise.all([ab, och]);
            let abDoc = response[0];
            let ochDoc = response[1];
            let ochData = ochDoc.data();

            let reachMax = true;
            if (abDoc && abDoc.docs && abDoc.docs.length < 50) {
                reachMax = false;
            }
            this.setState({ reachMax: reachMax });

            let total = 0;
            if (ochData && ochData.cart && ochData.cart.items && ochData.cart.items.length > 0) {
                let items = ochData.cart.items;
                let hasChanged = false;
                delete ochData.cart['deletedItem'];

                await Promise.all(items.map(async (item) => {
                    let itemSell = await iCollection.doc(item.id).get();
                    let itemSellData = itemSell.data();

                    let prevPrice = item.price;
                    let prevDeletedItem = item.deletedItem;
                    delete item['deletedItem'];
                    delete item['deletedText'];

                    if (!itemSellData) {
                        ochData.cart.deletedItem = true;
                        item.deletedItem = true;
                        item.deletedText = '販売終了';
                    } else if ((itemSellData && !itemSellData['price']) || (itemSellData && itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['price'])) {
                        ochData.cart.deletedItem = true;
                        item.deletedItem = true;
                        item.deletedText = '要見積';
                    } else if (itemSellData['price'] && itemSellData['price'][0] && !itemSellData['price'][0]['expiration_date']) {
                        ochData.cart.deletedItem = true;
                        item.deletedItem = true;
                        item.deletedText = '要見積';
                    } else if (itemSellData && itemSellData['price'] && itemSellData['price'][0] && itemSellData['price'][0]['expiration_date']) {
                        let expiration_date = itemSellData['price'][0]['expiration_date'];
                        let expDate = expiration_date && expiration_date.toDate ? expiration_date.toDate() : (expiration_date ? new Date(expiration_date.seconds * 1000) : new Date(0));

                        if ((expDate.getTime() - this.props.dateNow) < 0) {
                            ochData.cart.deletedItem = true;
                            item.deletedItem = true;
                            item.deletedText = '要見積';
                        } else {
                            if (!urigawa) item.price = itemSellData['price'][0]['price'];
                        }
                    } else {
                        if (!urigawa) item.price = itemSellData['price'][0]['price'];
                    }

                    if (!item.deletedItem) {
                        let changed = updateItemFromSellData(item, itemSellData, urigawa);
                        if (changed) hasChanged = true;
                    }
                    if (prevDeletedItem !== item.deletedItem) {
                        hasChanged = true;
                    }
                    if (prevPrice !== item.price && (prevPrice === undefined || Number(prevPrice) !== Number(item.price))) {
                        hasChanged = true;
                    }
                }));

                if (hasChanged) {
                    await ochRef.set(ochData, { merge: true });
                }
            }

            this.setState({ otasukeCart: ochData })

            let carriage_free = 0;
            let carriage = 0;
            if (this.props.org.maker && this.props.userOrg && this.props.userOrg.sellers) {
                this.props.userOrg.sellers.map((seller) => {
                    if (seller.organization == this.props.org.id) {
                        carriage_free = seller.carriage_free ? seller.carriage_free : 0;
                        carriage = seller.carriage ? seller.carriage : 0;
                    }
                })
            }
            if (this.props.org.reseller && this.props.userOrg) {
                carriage_free = this.props.userOrg.carriage_free ? this.props.userOrg.carriage_free : 0;
                carriage = this.props.userOrg.carriage ? this.props.userOrg.carriage : 0;
            }
            let postage = total < carriage_free ? carriage : 0;
            this.setState({ carriage: postage, loading: false })
        }
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.org !== prevProps.org || this.props.userOrg !== prevProps.userOrg) {
            this.getCart();
        }
    }

    componentDidMount() {
        this.getCart();
    }

    goBack = () => {
        this.props.cProps.history.goBack();
    }

    addToDeliveryAddress = (deliveryAddress) => {
        deliveryAddress.otasukeHistoryId = this.props.id;
        this.props.cProps.history.push('/deliveryAddressAdd', deliveryAddress);
    }

    deleteHelpCart = () => {
        const dTitle = this.state.otasukeCart?.cart?.cartName;
        this.setState({
            deleteId: this.props.id,
            deleteTitle: dTitle,
            deleteModal: true
        })
    }

    modalDelClose = () => {
        const dId = this.state.deleteId;
        if (dId) {
            let self = this;
            let otasukeCartHistoryRef = this.props.db.collection('otasuke_carts_history').doc(dId);
            otasukeCartHistoryRef.set({ sendHelpCart: 2 }, { merge: true })
                .then(function () {
                    message.success("お助けカートを削除しました。");
                    self.props.cProps.history.push('/otasuke/history/carts');
                })
                .catch(function (error) {
                    message.error("削除中にエラーが発生しました。");
                });
        }
        this.setState({ deleteModal: false, deleteId: null, deleteTitle: null });
    }

    cancelDelClose = () => {
        this.setState({ deleteModal: false, deleteId: null, deleteTitle: null });
    }

    addCart = () => {
        this.setState({ selectedItem: this.state.otasukeCart.cart }, () => {
            this.setState({ cartselect: true });
        });
    }

    showHideCart = (val) => {
        this.setState({ cartselect: val });
    }

    render() {
        if (!this.props.org) {
            return <div style={{ padding: 24, textAlign: 'center' }}><Text type="secondary">取引先を選択してください。</Text></div>;
        }

        if (this.state.loading) {
            return (
                <div style={{ textAlign: 'center', padding: 40 }}>
                    <Spin indicator={<LoadingOutlined style={{ fontSize: 28 }} spin />} />
                </div>
            );
        }

        const data = this.state.otasukeCart;
        if (!data || !data.cart) {
            return <Empty description="お助けカートが見つかりません" style={{ marginTop: 60 }} />;
        }

        const cart = data.cart;
        const items = cart.items || [];
        
        let total = 0;
        let postage = this.state.carriage;
        let taxes = {};
        let taxTotal = 0;

        const isBuyer = (this.props.userOrg && this.props.userOrg.buyer) || (this.props.userOrg && this.props.userOrg.reseller && this.props.org.maker);
        let dateLabel = '送信日時';
        if (isBuyer) dateLabel = '受信日時';

        items.forEach((item) => {
            if (!item.deletedItem) {
                if (item.tax) {
                    if (taxes[item.tax]) {
                        taxes[item.tax] += (item.count * item.price * item.tax);
                    } else {
                        taxes[item.tax] = (item.count * item.price * item.tax);
                    }
                    taxTotal += parseInt(item.count * item.price * item.tax, 10);
                }
                total += item.count * item.price;
            }
        });

        const subTotal = total;
        total += postage;
        const grandTotal = parseInt(total + taxTotal, 10);

        let orderNoukiText = cart.orderNouki;
        if (orderNoukiText === '希望') orderNoukiText += ` (${cart.orderNoukiDay}日)`;
        if (orderNoukiText === '日付指定' && cart.orderNoukiDate) {
            const date = cart.orderNoukiDate.toDate();
            orderNoukiText = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
        }

        let receivedDate = '-';
        if (data.created) {
            const date = data.created.toDate();
            const n = (num) => num > 9 ? "" + num : "0" + num;
            receivedDate = `${date.getFullYear()}/${n(date.getMonth() + 1)}/${n(date.getDate())} ${n(date.getHours())}:${n(date.getMinutes())}`;
        }

        let deliveryAddress = {};
        if (cart.orderBasyo === 'アドレス帳から選択する' || cart.orderBasyo === '前回の納品先') {
            deliveryAddress = cart.deliveryAddress || {};
        } else if (!(
            cart.orderPropertyName === '' &&
            cart.orderZipcode === '' &&
            cart.orderAddr1 === '' &&
            cart.orderAddr2 === '' &&
            cart.orderJigyosyo === '' &&
            cart.orderTanto === '' &&
            cart.orderPhone === ''
        )) {
            deliveryAddress = {
                propertyName: cart.orderPropertyName,
                postCode: cart.orderZipcode,
                address1: cart.orderAddr1,
                address2: cart.orderAddr2,
                officeName: cart.orderJigyosyo,
                personInCharge: cart.orderTanto,
                phoneNumber: cart.orderPhone,
            };
        }
        if (cart.orderBasyo === '納品先を直接入力する') {
            deliveryAddress = {
                propertyName: cart.orderPropertyName,
                postCode: cart.orderZipcode,
                address1: cart.orderAddr1,
                address2: cart.orderAddr2,
                officeName: cart.orderJigyosyo,
                personInCharge: cart.orderTanto,
                phoneNumber: cart.orderPhone,
            };
        }

        let disable = cart.deletedItem;
        let archiveFilter = items.filter(v => v.archive === true);
        if (archiveFilter.length > 0) disable = true;

        const renderAddress = () => {
            if (cart.orderBasyo === '納品先を指定しない') {
                return (
                    <Space direction="vertical" size={2}>
                        <Text>納品先は指定されていません</Text>
                        {isBuyer && <Text type="danger" style={{fontSize:11}}>カートに入れてから指定してください。</Text>}
                    </Space>
                );
            }
            if (Object.keys(deliveryAddress).length > 0) {
                return (
                    <div style={{fontSize: 13, lineHeight: '1.6'}}>
                        <div>物件名：{deliveryAddress.propertyName}</div>
                        <div>{deliveryAddress.postCode}</div>
                        <div>{deliveryAddress.address1} {deliveryAddress.address2} {deliveryAddress.officeName}</div>
                        <div>受取担当者：{deliveryAddress.personInCharge}</div>
                        <div>電話番号：{deliveryAddress.phoneNumber}</div>
                        <div style={{ marginTop: 12 }}>
                            <Button 
                                type="primary" 
                                onClick={() => this.addToDeliveryAddress(deliveryAddress)} 
                                disabled={this.state.reachMax}
                                style={{ backgroundColor: this.state.reachMax ? undefined : '#2D486A', width: '100%' }}>
                                この納品場所をアドレス帳に追加する
                            </Button>
                            {this.state.reachMax &&
                                <div style={{color: '#ff3547', fontSize: 11, marginTop: 4}}>
                                    保存可能な件数は５０件です。 いずれかを削除するか編集してご利用下さい。
                                </div>
                            }
                        </div>
                    </div>
                );
            }
            return <Text>{cart.orderBasyo}</Text>;
        };

        return (
            <div style={{ padding: '8px 12px', paddingBottom: 80, background: '#f5f5f5', minHeight: '100vh' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 4px 16px' }}>
                    <Button type="text" icon={<LeftOutlined />} onClick={this.goBack} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
                    <Title level={5} style={{ margin: 0 }}>{cart.cartName || "名称未設定"}</Title>
                </div>

                <div style={{ padding: '0 4px', marginBottom: 16 }}>
                    {items.map((item, idx) => (
                        <Card key={idx} bodyStyle={{ padding: 12 }} style={{ marginBottom: 12, borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
                            <div style={{ display: 'flex', gap: 12 }}>
                                <div style={{ width: 60, height: 60, background: '#eee', borderRadius: 8, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {item.image ? (
                                        <img src={item.image} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }} />
                                    ) : (
                                        <EyeOutlined style={{ color: '#aaa', fontSize: 20 }} />
                                    )}
                                </div>
                                <div style={{ flex: 1 }}>
                                    <Text strong style={{ fontSize: 13, lineHeight: '1.4' }}>{item.name}</Text>
                                    <div style={{ marginTop: 4, display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                                        <Text type="secondary" style={{ fontSize: 11 }}>メーカ：{item.maker || '-'}</Text>
                                        <Text type="secondary" style={{ fontSize: 11 }}>商品コード: {item.itemCode || item.code || '-'}</Text>
                                    </div>
                                    <div style={{ marginTop: 4, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        {item.price > 0 ? <Text type="secondary" style={{ fontSize: 12 }}>@¥{item.price.toLocaleString()}</Text> : <span/>}
                                        <Text style={{ fontSize: 14, color: '#d32f2f', fontWeight: 'bold' }}>
                                            {!item.deletedItem ? "¥" + (item.count * (item.price || 0)).toLocaleString() : "-"}
                                        </Text>
                                    </div>
                                </div>
                            </div>

                            <Divider style={{ margin: '12px 0' }} />
                            
                            <div style={{ display: 'flex', gap: 8, alignItems: 'flex-start' }}>
                                <div style={{ flex: 1 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                        <Text type="secondary" style={{ fontSize: 12, marginRight: 8, alignSelf: 'center' }}>数量</Text>
                                        <Space.Compact style={{ flex: 1, maxWidth: 120 }}>
                                            <Button disabled={true}>-</Button>
                                            <Input disabled={true} value={item.count} style={{ textAlign: 'center' }} />
                                            <Button disabled={true}>+</Button>
                                        </Space.Compact>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <Text type="secondary" style={{ fontSize: 12, marginRight: 8, marginTop: 4 }}>備考</Text>
                                        <Input.TextArea disabled={true} value={item.description || ''} rows={1} style={{ fontSize: 12, flex: 1 }} />
                                    </div>
                                </div>
                                <Button disabled={true} style={{ backgroundColor: '#8c98a4', color: 'white', borderColor: '#8c98a4', height: '100%', minHeight: 64 }}>
                                    削除
                                </Button>
                            </div>
                            
                            {item.deletedItem && (
                                <div style={{ marginTop: 8 }}><Text type="danger" style={{ fontSize: 11 }}>⚠ {item.deletedText}</Text></div>
                            )}
                            {item.archive && (
                                <div style={{ marginTop: 8 }}><Text type="danger" style={{ fontSize: 11 }}>⚠ 現在お取り扱いしていません</Text></div>
                            )}
                        </Card>
                    ))}
                </div>

                <Card bodyStyle={{ padding: '12px 16px' }} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', marginBottom: 20 }}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 12}}>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text>運賃</Text><Text>¥{postage.toLocaleString()}</Text>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text>小計</Text><Text>¥{subTotal.toLocaleString()}</Text>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Text>消費税額</Text><Text>¥{taxTotal.toLocaleString()}</Text>
                        </div>
                        {Object.keys(taxes).sort((a, b) => b - a).map(value => (
                            <div key={value} style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 12 }}>
                                <Text type="secondary" style={{fontSize: 12}}>消費税{value*100}%</Text><Text type="secondary" style={{fontSize: 12}}>¥{parseInt(taxes[value], 10).toLocaleString()}</Text>
                            </div>
                        ))}
                        <Divider style={{ margin: '8px 0' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Text strong style={{ fontSize: 15 }}>合計金額</Text>
                            <Text strong style={{ fontSize: 18, color: '#d32f2f' }}>¥{grandTotal.toLocaleString()}</Text>
                        </div>
                    </div>
                </Card>

                <div style={{ padding: '0 4px', marginBottom: 20 }}>
                    <div style={{display: 'flex', flexDirection: 'column', gap: 20}}>
                        <div>
                            <Text type="secondary" style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>発注番号</Text>
                            <Input disabled value={cart.orderNo || ''} style={{ backgroundColor: '#f2f4f8', color: '#495057' }} />
                        </div>
                        
                        <div>
                            <Text type="secondary" style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>お助けカート送信先</Text>
                            <Input disabled value={cart.toUserName || ''} style={{ backgroundColor: '#f2f4f8', color: '#495057' }} />
                        </div>

                        <div>
                            <Text type="secondary" style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>希望納期</Text>
                            <Radio.Group disabled value={cart.orderNouki} style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 4 }}>
                                <Radio value={'最短'}>
                                    最短
                                </Radio>
                                <Radio value={'希望'}>
                                    <Input disabled value={cart.orderNouki === '希望' ? cart.orderNoukiDay : ''} style={{ width: 80, margin: '0 8px', backgroundColor: '#f2f4f8' }} /> 日
                                </Radio>
                                <Radio value={'日付指定'}>
                                    日付指定 <Input disabled value={cart.orderNouki === '日付指定' ? orderNoukiText : ''} style={{ width: 140, marginLeft: 8, backgroundColor: '#f2f4f8' }} />
                                </Radio>
                            </Radio.Group>
                        </div>

                        <div>
                            <Text type="secondary" style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>納品場所</Text>
                            <div style={{ marginTop: 4 }}>
                                <Card bodyStyle={{ padding: '12px 16px' }} style={{ marginBottom: 12, borderColor: cart.orderBasyo !== '納品先を指定しない' ? '#e8e8e8' : '#e8e8e8', borderRadius: 4 }}>
                                    <Radio disabled checked={cart.orderBasyo !== '納品先を指定しない'}>
                                        <Text>納品先</Text>
                                    </Radio>
                                    {cart.orderBasyo !== '納品先を指定しない' && (
                                        <div style={{ paddingLeft: 24, marginTop: 8 }}>
                                            {renderAddress()}
                                        </div>
                                    )}
                                </Card>
                                <Card bodyStyle={{ padding: '12px 16px' }} style={{ borderColor: cart.orderBasyo === '納品先を指定しない' ? '#e8e8e8' : '#e8e8e8', borderRadius: 4 }}>
                                    <Radio disabled checked={cart.orderBasyo === '納品先を指定しない'}>
                                        <Text>納品先は指定されていません</Text>
                                    </Radio>
                                </Card>
                            </div>
                        </div>

                        <div>
                            <Text type="secondary" style={{ fontSize: 13, marginBottom: 4, display: 'block' }}>備考</Text>
                            <Input.TextArea disabled value={cart.orderBikou || ''} rows={4} style={{ backgroundColor: '#f2f4f8', color: '#495057' }} />
                        </div>
                    </div>
                </div>

                <div style={{ padding: '0 16px', marginBottom: 20, textAlign: 'center' }}>
                    <Text type="secondary" style={{fontSize: 12}}>カートID: {this.props.id}<br/>{dateLabel}: {receivedDate}</Text>
                </div>

                <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, padding: '10px 16px', background: '#fff', boxShadow: '0 -2px 10px rgba(0,0,0,0.05)', display: 'flex', gap: 12, zIndex: 100 }}>
                    {isBuyer ? (
                        <>
                            <Button danger icon={<DeleteOutlined />} size="large" onClick={this.deleteHelpCart} style={{ flex: 1, borderRadius: 8 }}>
                                削除
                            </Button>
                            <Button type="primary" icon={<ShoppingCartOutlined />} size="large" onClick={this.addCart} style={{ flex: 2, borderRadius: 8 }} disabled={disable}>
                                カートに追加
                            </Button>
                        </>
                    ) : (
                        <Button type="primary" icon={<ShoppingCartOutlined />} size="large" onClick={this.addCart} style={{ flex: 1, borderRadius: 8 }} disabled={disable}>
                            この履歴を使ってお助けカートを作成する
                        </Button>
                    )}
                </div>

                {isBuyer ? (
                    <OtasukeCartAllSelect
                        isOpen={this.state.cartselect}
                        isOpenEvent={this.showHideCart}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                ) : (
                    <OtasukeCartAllSelectOtasuke
                        isOpen={this.state.cartselect}
                        isOpenEvent={this.showHideCart}
                        db={this.props.db}
                        user={this.props.user}
                        data={this.state.selectedItem}
                        org={this.props.org}
                        userOrg={this.props.userOrg}
                        dateNow={this.props.dateNow}
                    />
                )}

                <Modal
                    title="お助けカート削除"
                    visible={this.state.deleteModal}
                    onCancel={this.cancelDelClose}
                    footer={[
                        <Button key="cancel" onClick={this.cancelDelClose}>キャンセル</Button>,
                        <Button key="delete" type="primary" danger onClick={this.modalDelClose}>OK</Button>
                    ]}
                >
                    <p>お助けカート「{this.state.deleteTitle}」を削除します。 よろしいですか？</p>
                </Modal>
            </div>
        );
    }
}

export default MobileOtasukeCartDetail;
